// export default ViewDetailsreturnGrn
import Grid from "@mui/material/Grid2";
import * as React from "react";
import { useState, useEffect, useCallback,useMemo } from "react";
import { AnyForNow } from "./types";
import { useStyles } from "../../assets/styles/Theme";
import {
  Box,
  Typography,
  Button,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { MSG_GRN_FAILED, MSG_GRN_SUCCESS } from "../../utils/sys/Messages";
import { submitGrnData } from "../../services/GrnApi";
import SystemAlert from "../../components/common/SystemAlert";
import { externalgetApi, externalpostApi } from "../../services/externalApis";
import {
  CON_BUSINESS_TYPECODE,
  CON_YES,
} from "../../utils/sys/Constants";
import { useGrnDetailLayout } from "../../features/grn/hooks/useGrnDetailLayout";
import { GRN_API_01, GRN_API_09, GRN_API_09_1 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
import PopUp from "../../components/popup/PopUp";
import ViewReturnDetailBody from "../../components/grn/ViewReturnDetailBody";
import Grnresattachments from "../../components/grn/Grnresattachments";
import { GRN_ROUTES } from "../../utils/sys/GrnRoutes";
import { useAlertQueue } from "../../hooks/useAlertQueue";
import {
  DOC_TYPE,
  GRN_ALERT_TYPE,
  GRN_CONSTRAINTS,
  GRN_DEFAULTS,
  GRN_DIALOG,
  GRN_RETURN_DEFAULTS,
  GRN_RETURN_PROCESS_STATUS,
  GRN_VIEW_RETURN_FILTER,
  PARAM_ID,
} from "../../utils/sys/GrnConstants";
import {
  BUTTON_LABELS,
  GRN_RETURN_DETAIL_LABELS,
} from "../../utils/sys/GrnLabels";
import { GRN_CONFIRM_MESSAGES, GRN_ERROR_MESSAGES, GRN_FAILURE_MESSAGES, GRN_SUCCESS_MESSAGES } from "../../utils/sys/GrnValidation";
import ViewGrnReturnInfo from "../../components/grn/ViewGrnReturnInfo";
import ReturnNotePdf from "../../features/documents/ReturnNotePdf";
// @ts-ignore
import DebitNotePdf from "../../features/documents/DebitNotePdf";
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";

const ViewDetailsreturnGrn: React.FC = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const location = useLocation();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const {
    grncode,
    trsts,
    billingSummary,
    taxValues,
    grnTaxTypes,
    totalDiscount, origin,
grnreturncode,returneddate
  } = location?.state || {};
  const { alertState, showAlert, handleClose: handleAlertClose } = useAlertQueue();
  const { open: alertOpen, type: alertType, message: alertMessage } = alertState;
  const [confirmHoldOpen, setConfirmHoldOpen] = useState<boolean>(false);

  const statusCode = location.state?.statusCode;

  const {
    grnItems = [],
    attachments = [],
    selectedSupplier = [],
    grnDetailsForm,
    returnedProducts = [],
    Returncal = [],
    grnData = [],
    grnHeader = [],

  } = location.state || {};
  const SYS_USER = useSelector((state: AnyForNow) => state.user) || {};
  const { COMPCODE, USERNAME, STAFFMAPLOCODE } = SYS_USER.USER_PARAM || {};
  const {
    rightSidebarRef,
    rightSidebarOpen,
    toggleRightSidebar,
    docType,
    openPdf,
    setOpenPdf,
    handleOpenPdf,
  } = useGrnDetailLayout();
  const moduleParamJson = useSelector((state: AnyForNow) => state.moduleParamJson);

  // console.log("item",item);
  const [grnList, setGrnList] = useState<AnyForNow[]>([]);
  const [grnProducts, setGrnProducts] = useState<AnyForNow[]>([]);
  const [trackingDetails, setTrackingDetails] = useState<AnyForNow[]>([]);
  const [grnDocuments, setGrnDocuments] = useState<AnyForNow[]>([]);
  const [grnReturns, setGrnReturns] = useState<AnyForNow[]>([]);
  const [grnPaySummery, setGrPaySummery] = useState<AnyForNow[]>([]);
  const [grnPayTax, setGrnPayTax] = useState<AnyForNow[]>([]);
  const [grnReturnMaster, setGrnReturnMaster] = useState<AnyForNow[]>([]);
  const [grnreject, setGrnreject] = useState<AnyForNow[]>([]);
  const [grnCompany, setGrnCompany] = useState<AnyForNow[]>([]);
  const [description, setDescription] = useState<string>(GRN_DEFAULTS.STRING);
  const [resattachments, setresAttachments] = useState<AnyForNow[]>([]);
  const [selectedReason, setSelectedReason] = useState<string>(GRN_DEFAULTS.STRING);
  console.log("selectedReason", selectedReason);

  const sanitizedReturnedProducts = React.useMemo(
    () =>
      Array.isArray(returnedProducts)
        ? returnedProducts.filter((item) => Number(item?.returnedqty) > 0)
        : [],
    [returnedProducts]
  );
  const filteredReturnedProducts = useMemo(
    () =>
      Array.isArray(returnedProducts)
        ? returnedProducts.filter((item) => Number(item?.returnedqty) > 0)
        : [],
    [returnedProducts]
  );
  const sanitizedReturnCal = React.useMemo(() => {
    if (!Array.isArray(Returncal)) return [];

    return Returncal.map((entry) => {
      const items = Array.isArray(entry?.grnReturnItems)
        ? entry.grnReturnItems.filter(
            (itm: AnyForNow) => Number(itm?.returnedqty) > 0
          )
        : [];

      return {
        ...entry,
        grnReturnItems: items,
      };
    }).filter(
      (entry) =>
        (Array.isArray(entry.grnReturnItems) &&
          entry.grnReturnItems.length > 0) ||
        (Array.isArray(entry.grnReturnSummaries) &&
          entry.grnReturnSummaries.length > 0)
    );
  }, [Returncal]);

  const handleSubmit = () => {
    submitGrnData({
      grnItems,
      attachments,
      grnDetailsForm,
      selectedSupplier,
      USERNAME,
      COMPCODE,
      STAFFMAPLOCODE,
      grncode,
      grnTaxTypes,
      taxValues,
      totalDiscount,
      trsts: String(statusCode),

      onSuccess: (response) => {
        console.log("GRN...", response);
        showAlert(MSG_GRN_SUCCESS, GRN_ALERT_TYPE.SUCCESS);
        // goNextToView("success");
        setTimeout(() => {
          navigate(GRN_ROUTES.LIST);
        }, GRN_CONSTRAINTS.NAVIGATION_TIMEOUT);
      },
      onError: (error) => {
        console.error("Failed to create GRN:", error);
        showAlert(MSG_GRN_FAILED, GRN_ALERT_TYPE.ERROR);
      },
    });
  };

  const fetchGrnData = useCallback(async (currentGrnCode: string, currentTrsts: string) => {
    try {
      const result = await externalgetApi(GRN_API_01, "GET", {
        COMPCODE,
        GRNCODE: currentGrnCode,
        STS: currentTrsts,
      });
      console.log("resultYYYYYYYYYYY", result);
      setGrnList(result || []);
      setGrnProducts(result?.[0]?.products || []);
      setTrackingDetails(result?.[0]?.tracking || []);
      setGrnReturns(result?.[0]?.returns || []);
      setGrnDocuments(result?.[0]?.documents || []);
      setGrPaySummery(result?.[0]?.grnPaySummery || []);
      setGrnPayTax(result?.[0]?.grnPayTax || []);
      setGrnReturnMaster(result?.[0]?.grnReturnMaster || []);
      setGrnCompany(result?.[0]?.company || []);
      setGrnreject(result?.[0]?.rejectList || []);
    } catch (err) {
      console.error("Error fetching GRN data:", err);
      showAlert(GRN_FAILURE_MESSAGES.FETCH_GRN_FAILED, GRN_ALERT_TYPE.ERROR);
    }
  }, [COMPCODE, showAlert]);

  useEffect(() => {
    if (grncode && trsts) {
      fetchGrnData(grncode, trsts);
    } else {
      // console.warn("Missing grncode or trsts in location.state");
      // setAlertType("error");
      // setAlertMessage("Missing GRN code or status");
      // setAlertOpen(true);
    }
  }, [fetchGrnData, grncode, trsts]);

  const productsToDisplay =
    grnList.length > 0 &&
    Array.isArray(grnList[0].products) &&
    grnList[0].products.length > 0
      ? grnList[0].products
      : grnItems || [];

const handleCancelReturn = () => {
  if (origin === GRN_VIEW_RETURN_FILTER.ORIGIN_EDIT_RETURN) {
    navigate(GRN_ROUTES.VIEW_MY_ACTION_INITIATOR);
  } else {
    navigate(GRN_ROUTES.RETURN_GRN);
  }
};

  const handleConfirmReturn = async () => {
    if (!sanitizedReturnedProducts || sanitizedReturnedProducts.length === 0) {
      showAlert(GRN_ERROR_MESSAGES.RETURN_NO_PRODUCTS, GRN_ALERT_TYPE.ERROR);
      return;
    }
    const moduleParamJsonArray = Array.isArray(moduleParamJson)
      ? moduleParamJson
      : Object.values(moduleParamJson || {});
    // Get PARAID and PARAVALUE from Redux
    const PARAID = moduleParamJson?.[0]?.PARAID;
    const PARAVALUE = moduleParamJson?.[0]?.PARAVALUE;

    // Conditionally set sts
    const stsValue =
      moduleParamJsonArray.filter((item) => item.PARAID === PARAM_ID.APPROVAL_WORKFLOW)[0]
        ?.PARAVALUE === CON_YES
        ? GRN_RETURN_PROCESS_STATUS.APPROVAL_REQUIRED
        : GRN_RETURN_PROCESS_STATUS.DIRECT_RETURN;

    const payload = {
      grndoccode: DOC_TYPE.REJECT,
      grncode: grncode,
      grnreturncode:grnreturncode,
      descrip: description, // <-- Pass the value here
      reason: selectedReason, // <-- Pass the value here
      compcode: COMPCODE,
      loccode: STAFFMAPLOCODE,
      businesstypecode: CON_BUSINESS_TYPECODE,
      enuser: SYS_USER?.USER_PARAM?.USERNAME || GRN_RETURN_DEFAULTS.ENUSER_FALLBACK,
      sts:"1", //stsValue, // <-- conditional
      TRSTS: String(stsValue),
      dtProductReturns: sanitizedReturnedProducts,
      dtoReturnDOCs:
        resattachments && resattachments.length > 0
          ? resattachments.map((att) => ({
              doctypecode: att.doctypecode || GRN_DEFAULTS.STRING,
              doctypeothername: att.doctypeothername || GRN_DEFAULTS.STRING,
              docpathjson: att.docpathjson || GRN_DEFAULTS.STRING, // always empty string
              filename: att.docpathjson || GRN_DEFAULTS.STRING,
              bytarr:  GRN_DEFAULTS.STRING,
              remark: att.docremark || GRN_DEFAULTS.STRING,
            }))
          : [
              {
                doctypecode: DOC_TYPE.DEFAULT,
                doctypeothername: GRN_DEFAULTS.STRING,
                docpathjson: GRN_DEFAULTS.STRING,
                filename: GRN_DEFAULTS.STRING,
                bytarr: GRN_DEFAULTS.STRING,
                remark: GRN_DEFAULTS.STRING,
              },
            ],
    };

    console.log("Payload for GRN return:", payload);

    try {
      const response = await externalpostApi(GRN_API_09_1, payload);
      console.log("Response from GRN update:", response);

      showAlert(
        `${grncode} ${GRN_SUCCESS_MESSAGES.RETURN_SUCCESS}`,
        GRN_ALERT_TYPE.SUCCESS
      );

      setTimeout(() => {

if (origin === GRN_VIEW_RETURN_FILTER.ORIGIN_EDIT_RETURN) {
    navigate(GRN_ROUTES.VIEW_MY_ACTION_INITIATOR);
} else
        navigate(GRN_ROUTES.RETURN_GRN);
      }, GRN_CONSTRAINTS.DEFAULT_WAIT_TIME);
    } catch (error) {
      console.error("Error updating GRN:", error);
      showAlert(GRN_FAILURE_MESSAGES.UPDATE_FAILED, GRN_ALERT_TYPE.ERROR);
    }
  };

  return (
    <>
      <Box
        sx={{
          mx: "auto",
          p: 2,
          background: theme.palette.background.paper,
        }}
      >
        <ViewReturnDetailBody
          // grnItems={grnItems}
          grnItems={productsToDisplay}
          selectedSupplier={selectedSupplier}
          grnDetailsForm={grnDetailsForm}
          attachments={attachments}
          statusCode={statusCode}
          grnHeader={grnList.length > 0 ? grnList[0].header : null}
          grncode={grncode}
          trackingDetails={trackingDetails}
          trsts={trsts}
          grnDocuments={grnDocuments}
          returnedProducts={sanitizedReturnedProducts}
          Returncal={sanitizedReturnCal}
          grnReturns={grnReturns}
          grnPaySummery={grnPaySummery}
          grnPayTax={grnPayTax}
          grnReturnMaster={grnReturnMaster}
          billingSummary={billingSummary}
          totalGross={billingSummary?.grossAmount || GRN_DEFAULTS.NUMBER}
          taxValues={taxValues}
          grnTaxTypes={grnTaxTypes}
          grnCompany={grnCompany}
          grnData={grnList.length > 0 ? grnList[0].products : null}
          grnreject={grnreject}
          grnreturncode = {grnreturncode}
          returneddate ={returneddate}
        />

        <Divider />
   <Grid container spacing={6} mt={3}>
  {/* Left Section */}
  <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
    <Box sx={{ width: "100%", mb: 6,border: `1px solid`, borderColor: "divider", borderRadius: 2, p: 2 }}>
      <TextField
        label={GRN_RETURN_DETAIL_LABELS.REASON_REMARK}
        value={selectedReason}
        onChange={(e) => setSelectedReason(e.target.value)}
        fullWidth
        variant="outlined"
        sx={{ mb: 2 }}
        size="small"
        multiline
      />

      <TextField
        label={GRN_RETURN_DETAIL_LABELS.DESCRIPTION}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        fullWidth
        variant="outlined"
        sx={{ mb: 2 }}
        size="small"
        multiline
      />

      <Grnresattachments
        attachments={resattachments}
        setAttachments={setresAttachments}
      />
    </Box>
  </Grid>

  {/* Right Section */}
  <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
      <Box sx={{ width: "100%", mb: 6,border: `1px solid`, borderColor: "divider", borderRadius: 2, p: 2 }}>
    <Typography sx={styles.grn_sub_title_text} gutterBottom>
      Financial Information
    </Typography>

    <Divider />

    <ViewGrnReturnInfo
      grnPaySummery={grnPaySummery}
      grnPayTax={grnPayTax}
      billingSummary={billingSummary}
      taxValues={taxValues}
      grnTaxTypes={grnTaxTypes}
      grnItems={grnItems}
      returnedProducts={filteredReturnedProducts}
      Returncal={Returncal}
      grnReturnMaster={grnReturnMaster}
      grnReturns={
        Array.isArray(grnReturns) && grnReturns.length
          ? grnReturns
          : filteredReturnedProducts
      }
    />
   

         {/* <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Divider />
            <Button
              variant="contained"
              color="primary"
              size="small"
              sx={{ ...styles.btn_primary }}
              onClick={() => handleOpenPdf("Debit Note")}
            >
              View Debit Note
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              sx={{ ...styles.btn_primary }}
              onClick={() => handleOpenPdf("Return Note")}
            >
              View Return Note
            </Button>
          </Grid>  */}
            </Box>
  </Grid>
</Grid>
      <Dialog
        open={openPdf}
        onClose={() => setOpenPdf(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          {docType} Preview
          <IconButton
            aria-label="close"
            onClick={() => setOpenPdf(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <DisabledByDefaultOutlinedIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {docType === "Return Note" ? (
            <ReturnNotePdf
           grnHeader={grnList.length > 0 ? grnList[0].header : null}
              grnItems={grnProducts}
              docType={docType}
              selectedSupplier={selectedSupplier}
              grnDetailsForm={grnDetailsForm}
              grnPaySummery={grnPaySummery}
               returnedProducts={filteredReturnedProducts}
                Returncal = {Returncal}
              grnReturnMaster={grnReturnMaster}
              // grnReturns={grnReturns || returnedProducts}
              grnReturns={
                Array.isArray(grnReturns) && grnReturns.length
                  ? grnReturns
                  : filteredReturnedProducts
              }
              grnData={grnData}
              grnCompany={grnCompany}
            />
          ) : (
            <DebitNotePdf
             grnHeader={grnList.length > 0 ? grnList[0].header : null}
              grnItems={grnProducts}
              docType={docType}
              selectedSupplier={selectedSupplier}
              grnDetailsForm={grnDetailsForm}
              grnPaySummery={grnPaySummery}
               returnedProducts={filteredReturnedProducts}
                Returncal = {Returncal}
              // grnReturns={grnReturns || returnedProducts}
              grnReturns={
                Array.isArray(grnReturns) && grnReturns.length
                  ? grnReturns
                  : filteredReturnedProducts
              }
              grnData={grnData}
              grnCompany={grnCompany}
            />
          )}
        </DialogContent>
      </Dialog>
        <Box
          my={2}
          pb={2}
          gap={2}
          width={"100%"}
          display={"flex"}
          justifyContent={"flex-end"}
        >
          <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            sx={{
              display: "flex",
              gap: 1,
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              size="small"
              sx={{ ...styles.btn_secondary }}
              onClick={() => navigate(-1)}
            >
              {BUTTON_LABELS.BACK}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              sx={{ ...styles.btn_secondary }}
              onClick={handleCancelReturn}
            >
              {BUTTON_LABELS.CANCEL}
            </Button>

            <Button
              variant="contained"
              color="primary"
              size="small"
              sx={{ ...styles.btn_primary }}
              onClick={() => setConfirmDialogOpen(true)} // Open the confirmation dialog
            >
              {BUTTON_LABELS.CONFIRM}
            </Button>
          </Grid>
        </Box>
      </Box>
      <SystemAlert
        open={alertOpen}
        type={alertType}
        message={alertMessage}
        onClose={handleAlertClose}
      />

      <Dialog
        open={confirmDialogOpen}
        onClose={() => setConfirmDialogOpen(false)}
        fullWidth
        maxWidth={GRN_DIALOG.MAX_WIDTH}
      >
        <DialogTitle>
          {BUTTON_LABELS.CONFIRM} {BUTTON_LABELS.PURCHASES_RETURN}
        </DialogTitle>
        <DialogContent>
          <Typography>
            {GRN_CONFIRM_MESSAGES.RETURN_GRN}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            sx={{ ...styles.btn_secondary, textTransform: "capitalize" }}
            onClick={() => setConfirmDialogOpen(false)} // Close the dialog
          >
            {BUTTON_LABELS.CANCEL}
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ ...styles.btn_primary }}
            onClick={() => {
              setConfirmDialogOpen(false); // Close the dialog
              handleConfirmReturn(); // Call the confirm return function
            }}
          >
            {BUTTON_LABELS.CONFIRM}
          </Button>
        </DialogActions>
      </Dialog>

      <PopUp
        open={confirmHoldOpen}
        handleClose={() => setConfirmHoldOpen(false)}
        title={GRN_CONFIRM_MESSAGES.HOLD_GRN}
        content={
          <Typography variant="body1">
            {GRN_CONFIRM_MESSAGES.HOLD_GRN_WARNING}
          </Typography>
        }
        actions={
          <>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setConfirmHoldOpen(false)}
            >
              {BUTTON_LABELS.NO}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setConfirmHoldOpen(false);
              handleSubmit();
              }}
            >
              {BUTTON_LABELS.YES}
            </Button>
          </>
        }
      />
    </>
  );
};

export default ViewDetailsreturnGrn;
